const initPriceList = () => {
  /*
   * Prepínanie medzi cenníkmi.
   */
  const priceListLinks = document.querySelectorAll(".pricelist-btn")

  priceListLinks.forEach((link) => {
    link.addEventListener("click", (evt) => {
      evt.preventDefault()

      $(".pricelists").show()

      priceListLinks.forEach((link) => {
        // vzhľad všetkých tlačidiel sa nastaví na neaktívny
        link.style.backgroundColor = null
        link.style.color = null
        // všetky otvorené cenníky sa schovajú
        $(`#${link.dataset.target}`).hide()
      })

      // zvýrazní sa aktívne tlačidlo
      link.style.backgroundColor = "white"
      link.style.color = "black"
      // otvorí sa požadovaný cenník
      $(`#${link.dataset.target}`).fadeIn()
    })
  })
}

export default initPriceList
